import { render, staticRenderFns } from "./SkillsAddNew.vue?vue&type=template&id=088af7f8&"
import script from "./SkillsAddNew.vue?vue&type=script&lang=js&"
export * from "./SkillsAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SkillsAddNew.vue?vue&type=style&index=0&id=088af7f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports